<template>
  <section class="w-full h-screen 3xl:container">
    <div class="w-full h-full bg-slate-50">
      <slot name="content"></slot>
    </div>
  </section>
</template>

<script setup lang="ts"></script>
